<template>
  <div>
    <div
      v-for="score in scores"
      :key="score.value"
      class="button mb-3"
      :class="{ 'is-primary': score.active, 'is-outlined is-primary': !score.active }"
      style="height: 40px; width: 100%; margin: 0 0.3rem"
      @click="!disabled && selectAnswer(score.value)"
    >
      <div>
        {{ score_map[score.value] }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const SCORES_DEFAULT = [
  { active: false, value: 0 },
  { active: false, value: 1 },
  { active: false, value: 2 },
  { active: false, value: 3 },
  { active: false, value: 4 },
];

const props = defineProps({
  disabled: { type: Boolean },
  default_value: { type: Number, default: null },
});

const emit = defineEmits(['scoreSelected']);

const { t } = useI18n();

const scores = ref(_.cloneDeep(SCORES_DEFAULT));

const score_map = computed(() => ({
  0: t('survey.labels.very_satisfied'),
  1: t('survey.labels.satisfied'),
  2: t('survey.labels.neither_satisfied_nor_dissatisfied'),
  3: t('survey.labels.dissatisfied'),
  4: t('survey.labels.very_dissatisfied'),
}));

watch(
  () => props.default_value,
  () => {
    scores.value = _.cloneDeep(SCORES_DEFAULT);
    if (!_.isNil(props.default_value)) scores.value[props.default_value].active = true;
  },
  { immediate: true },
);

const selectAnswer = (answer) => {
  scores.value = _.cloneDeep(SCORES_DEFAULT);
  scores.value[answer].active = true;
  emit('scoreSelected', scores.value[answer].value);
};
</script>
